export default {
    submitVerification(id, data) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.post(
                `/rest/ocr/${id}/purInvoice/create`, 
                {},
                data,
                response => {
                    resolve(response);
                }, err => {
                    reject(err.response.data.error.message);
                });
        });
    },

    getOcrById(id) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/ocr/${id}`,
                {},
                response => {
                    resolve(response);
                }, err => {
                    reject(err.response.data.error.message);
                });
        });
    },

    getTagsPurInvoice() {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(`/tags/category/purchase`, {},
                (data) => { resolve(data) },
                (error) => { reject(error) }
            );
        })
    },

    searchOcrInvoice(data) {
        return window.ApiClient.post('/ocr/pur-invoice/search', {}, data);
    },

    deleteOcr(id) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.del(
                `/rest/ocr/${id}`,
                {},
                response => {
                    resolve(response);
                }, err => {
                    reject(err.response.data.error.message);
                }
            );
        });
    }
}